import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { productSelector } from 'selectors/page/product/productSelector';
import { localeSelector } from 'viewModel/selectors/locale/localeSelector';
import { isGenAIPRSEnabledSelector } from 'ai/selectors/killSwitches/isGenAIPRSEnabledSelector';
import ProductActions from 'actions/ProductActions';

const { wrapHOC } = FrameworkUtils;
const { loadHighlightedReviews } = ProductActions;

const fields = createSelector(productSelector, localeSelector, isGenAIPRSEnabledSelector, (product, language, showPrsModule) => {
    return {
        selectedSentiment: product.selectedSentiment,
        language,
        showPrsModule
    };
});

const functions = {
    loadHighlightedReviews
};

const withRatingsAndReviewsProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withRatingsAndReviewsProps
};
